import { useContext, useEffect, useRef, useState } from 'react';
import { User, HelpCircle, Ticket, Info, LogOut } from 'lucide-react';
import { GlobalComponentsContext } from 'context/GlobalComponentsContext';
import {
  StyledMobileMenu,
  MobileMenuHeader,
  CloseButton,
  MobileUserInfo,
  MobileUserIcon,
  MobileMenuItems,
  MobileMenuItem,
  MobileFooter,
  SocialIcon,
} from './styled';
import { AuthContext } from 'context';
import { URLS } from 'constants/urls';
import * as Sentry from '@sentry/react';
export const MobileMenu = () => {
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const { authContext } = useContext(AuthContext);
  const { user } = authContext;

  const { globalComponentsContext, setGlobalComponentsContext } = useContext(GlobalComponentsContext);
  const { isMobileProfileOpen } = globalComponentsContext;

  const handleMobileProfileClose = () => {
    setGlobalComponentsContext(prevState => ({
      ...prevState,
      isMobileProfileOpen: false,
    }));
  };

  const logout = () => {
    if (process.env.REACT_APP_MODE === 'local') {
      Sentry.logger.info('[logout] menu mobile');
      window.location.href = `${process.env.REACT_APP_URL}/logout`;
    } else {
      window.location.href = `${process.env.REACT_APP_LEGADO}/security/signout.aspx`;
    }
  };

  const handleOutsideClick = event => {
    if (
      (menuRef.current && !menuRef.current.contains(event.target)) ||
      (buttonRef.current && !buttonRef.current.contains(event.target))
    ) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleOutsideClick);
    } else {
      document.removeEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <StyledMobileMenu isOpen={isMobileProfileOpen}>
      <MobileMenuHeader>
        <a href="https://leankeep.movidesk.com/kb" className="help-button">
          <HelpCircle size={16} />
          Central de Ajuda
        </a>
        <CloseButton onClick={handleMobileProfileClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </CloseButton>
      </MobileMenuHeader>

      <MobileUserInfo>
        <MobileUserIcon>
          <User size={24} />
        </MobileUserIcon>
        <div>
          <div className="user-name">{user?.name || 'User'}</div>
          <div className="user-email">{user?.email || ''}</div>
        </div>
      </MobileUserInfo>

      <MobileMenuItems>
        <MobileMenuItem href={URLS.account}>
          <User size={20} />
          Minha Conta
        </MobileMenuItem>
        <MobileMenuItem href={URLS.tickets}>
          <Ticket size={20} />
          Meus Tickets
        </MobileMenuItem>
        <MobileMenuItem
          onClick={() =>
            setGlobalComponentsContext({
              ...globalComponentsContext,
              isMobileMenuOpen: true,
            })
          }
          onKeyPress={() =>
            setGlobalComponentsContext({
              ...globalComponentsContext,
              isMobileMenuOpen: true,
            })
          }
        >
          <Info size={20} />
          Sobre
        </MobileMenuItem>
        <MobileMenuItem onClick={() => logout()}>
          <LogOut size={20} />
          Sair
        </MobileMenuItem>
      </MobileMenuItems>

      <MobileFooter>
        <span>o Leankeep!</span>
        <div className="social-icons">
          <SocialIcon href="#" aria-label="Instagram">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </SocialIcon>
          <SocialIcon href="#" aria-label="LinkedIn">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
          </SocialIcon>
        </div>
      </MobileFooter>
    </StyledMobileMenu>
  );
};
